"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const HelpIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.96 3.867c.058-.1.116-.126.186-.135a.697.697 0 0 1 .416.105.697.697 0 0 1 .3.308c.027.065.034.127-.025.228l-1.329 2.302-2.856 4.948a.85.85 0 0 0 1.473.85l3.4-5.89c.066-.114.137-.148.212-.161a.614.614 0 0 1 .383.08c.142.078.22.18.25.256.018.05.036.132-.051.282-.418.725-.661 1.143-.821 1.418l-.149.255c-.07.121-.123.21-.178.307a.856.856 0 0 0-.05.1c-.04.06-.078.12-.114.184l-2.309 3.998a.85.85 0 1 0 1.473.85l2.308-3.998c.167-.29.325-.359.4-.377a.394.394 0 0 1 .308.064.57.57 0 0 1 .24.323c.032.118.032.281-.087.487-.39.677-.912 1.592-1.453 2.545l-.001.001-.92 1.618c-.849 1.485-1.565 2.723-1.776 3.028-.474.688-1.06 1.376-2.153 1.917-.99.49-3.556 1.134-5.752-.133-2.137-1.234-2.585-3.518-2.54-4.51L5.87 7.984c.036-.158.109-.231.184-.275a.65.65 0 0 1 .414-.065c.17.025.31.1.393.187.07.073.124.176.113.35-.031.522-.18 1.424-.331 2.237a63.238 63.238 0 0 1-.264 1.331l-.018.084-.006.028a.85.85 0 0 0 1.568.603l4.686-8.116c.061-.106.121-.13.186-.14a.649.649 0 0 1 .394.097.65.65 0 0 1 .281.293c.023.058.032.12-.02.217l-.51.884a.732.732 0 0 0-.01.019l-2.653 4.593a.85.85 0 0 0 1.473.85l3.164-5.482.017-.029 1.03-1.783Zm-1.528-.753.056-.097a1.924 1.924 0 0 1 1.432-.97c.537-.073 1.068.072 1.493.317.424.246.815.633 1.021 1.134.168.408.201.868.055 1.323.159.05.31.115.452.192.43.238.824.627 1.019 1.145.205.545.163 1.158-.169 1.732l-.167.289c.172.058.333.137.482.232.91.584 1.415 1.862.706 3.09a496.51 496.51 0 0 0-1.443 2.528l-.927 1.628c-.821 1.439-1.588 2.769-1.852 3.152-.57.825-1.356 1.761-2.8 2.475-1.263.625-4.476 1.477-7.355-.185-2.91-1.68-3.467-4.757-3.385-6.122a.847.847 0 0 1 .009-.082l1.135-7.198a.856.856 0 0 1 .007-.038c.28-1.37 1.527-1.84 2.51-1.697.86.124 1.784.752 1.941 1.839l2.484-4.303a1.93 1.93 0 0 1 1.417-.973 2.339 2.339 0 0 1 1.486.308c.136.079.27.173.393.28Z"
}));
exports.HelpIcon = HelpIcon;